import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolveAppLocale, setAppLocale, SUPPORTED_LOCALES } from '../../i18n';

const LOCALE_BUTTONS = [
  { code: 'en', label: 'EN' },
  { code: 'it', label: 'IT' },
  { code: 'es', label: 'ES' },
];

/** EN | IT | ES segmented pill — matches app-suite-rn LoginScreen langToggle. */
const LanguageSelect = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const activeLocale = resolveAppLocale(i18n.language);

  return (
    <div
      className={`login-lang-toggle ${className}`.trim()}
      role="group"
      aria-label={t('common.language')}
    >
      {LOCALE_BUTTONS.filter((opt) => SUPPORTED_LOCALES.includes(opt.code)).map(
        (opt) => (
          <button
            key={opt.code}
            type="button"
            className={`login-lang-btn${
              activeLocale === opt.code ? ' login-lang-btn--active' : ''
            }`}
            onClick={() => setAppLocale(opt.code)}
            aria-pressed={activeLocale === opt.code}
          >
            {opt.label}
          </button>
        ),
      )}
    </div>
  );
};

export default LanguageSelect;
